export const HPITemplateControllerFactory = ({
  hpiTemplateService,
}: {
  hpiTemplateService: IHPITemplateService;
}) => {
  const createHPITemplate: ICreateHPITemplateService = async (payload) => {
    const response = await hpiTemplateService.createHPITemplate(payload);
    return response;
  };

  const getHPITemplates: IGetHPITemplatesService = async (payload) => {
    const response = await hpiTemplateService.getHPITemplates(payload);
    return response;
  };

  const getSingleHPITemplate: IGetSingleHPITemplateService = async (
    payload
  ) => {
    const response = await hpiTemplateService.getSingleHPITemplate(payload);
    return response;
  };

  const updateHPITemplate: IUpdateHPITemplateService = async (payload) => {
    const response = await hpiTemplateService.updateHPITemplate(payload);
    return response;
  };

  const deleteHPITemplate: IDeleteHPITemplateService = async (payload) => {
    const response = await hpiTemplateService.deleteHPITemplate(payload);
    return response;
  };

  return {
    createHPITemplate,
    getHPITemplates,
    getSingleHPITemplate,
    updateHPITemplate,
    deleteHPITemplate,
  };
};

export type IHPITemplateController = ReturnType<
  typeof HPITemplateControllerFactory
>;
